// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b7nb","colBig":"styles_colBig__2USoi","colSmall":"styles_colSmall__w-II5"};